import { Component, inject, Input, input, OnInit } from '@angular/core';
import { NgxIcon } from '@digipay/ngx-icon';
import { DecimalPipe, NgTemplateOutlet, SlicePipe } from '@angular/common';
import { PipesModule } from '@digipay/ng-lib-pipes';
import { ImageComponent } from '../../../../shared/components/image/image.component';
import { FormatedDate } from '../../../../shared/pipes/formated-date.pipe';
import { PortfolioDetail } from '../../../../data-access/models/portfolio-detail.model';
import { ALLPROFILES, CROWD_LIST_ROUTE, INVESTMENT_LIST_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { FilteredPortfo, FilterPortfoPipe } from '../../pipes/filter-portfo.pipe';
import { LocationService } from '../../../../shared/services/location.service';

@Component({
  selector: 'app-portfo-profiles-asset',
  standalone: true,
  imports: [NgxIcon, ImageComponent, DecimalPipe, PipesModule, SlicePipe, FormatedDate, NgTemplateOutlet],
  templateUrl: './portfo-profiles-asset.component.html',
  styleUrl: './portfo-profiles-asset.component.scss',
})
export class PortfoProfilesAssetComponent implements OnInit {
  @Input() assetData: PortfolioDetail[];
  balance = input<number>(0);
  crowdBalance = input<number>(0);
  ipoBalance = input<number>(0);
  stockBalance = input<number>(0);
  canSee = input.required<boolean>();
  navigationService = inject(WealthNavigationService);
  location = inject(LocationService);

  filterPortfo = new FilterPortfoPipe();
  assets: FilteredPortfo = { crowd: [], fund: [], ipo: [], stock: [] };

  ngOnInit() {
    this.assets = this.filterPortfo.transform(this.assetData);
  }

  goToProfile() {
    this.navigationService.navigate([INVESTMENT_LIST_ROUTE]);
  }

  goToMore(type) {
    this.navigationService.navigateWithQueryParams([ALLPROFILES], {
      queryParams: { type },
    });
  }

  goToDetail(item: PortfolioDetail) {
    this.location.saveRoute('/portfo');
    switch (item.investmentType) {
      case 'CrowdFund':
        this.navigationService.navigate([CROWD_LIST_ROUTE, item.symbol]);
        break;
      case 'ETF':
        this.navigationService.navigate([INVESTMENT_LIST_ROUTE, item.symbol]);
        break;

      // case 'IPO':
      //   this.navigationService.navigate([IPO_DETAIL_ROUTE], {
      //     queryParams: { id: item.id },
      //   });
      //   break;
      default:
        this.navigationService.navigate([INVESTMENT_LIST_ROUTE, item.symbol]);
        break;
    }
  }

  protected readonly JSON = JSON;
}
